import BackendService from "./BackendService";

async function getItems(params) {
  const a = await BackendService.getData("/items/", params);
  return a;
}

async function getItemsResponse(params) {
  return BackendService.get("/items/", {}, params);
}
async function getItemNames(data = {}) {
  return BackendService.getData("/items/name_list/", data);
}
async function updateItem(itemId, data = {}) {
  return BackendService.put(`/item/${itemId}/`, data);
}
async function addItem(data = {}) {
  return BackendService.postData("/items/", data);
}
async function getItemCategories(data = {}) {
  return BackendService.getData("/categories/", data);
}
async function addItemCategory(data = {}) {
  return BackendService.postData("/categories/", data);
}
async function uploadCategoryImage(data = {}, id) {
  return BackendService.postData(`/category/${id}/image/`, data);
}
async function uploadItemImage(data = {}, id) {
  return BackendService.postData(`/item/${id}/image/`, data);
}
async function editItemCategory(data = {}, id) {
  return BackendService.put(`/category/${id}/`, data);
}
async function updatePlu() {
  return BackendService.postData("/items/update_plu_text/", "");
}
async function updateItems(data) {
  return BackendService.postData("/items/batch/", data);
}
async function getItemAdvanced(id) {
  return BackendService.getData(`/items/${id}/advanced/`);
}
async function updateItemAdvanced(data = {}, id) {
  return BackendService.put(`/items/${id}/advanced/`, data);
}
async function getPriceCategories(params) {
  return BackendService.getData("/price-categories/", params);
}
async function getPriceCategoryItems(params) {
  return BackendService.getData("/price-categories/items/", params);
}
async function getAddonMappings(params) {
  return BackendService.getData("/items/addon-mappings/", params);
}
async function getChargeGroups(params) {
  return BackendService.getData("/charge-groups/", params);
}

async function getCharges(params) {
  return BackendService.getData("/charges/", params);
}

const ItemService = {
  getItems,
  getItemsResponse,
  getItemCategories,
  getItemNames,
  updateItem,
  addItem,
  addItemCategory,
  editItemCategory,
  uploadCategoryImage,
  uploadItemImage,
  updatePlu,
  updateItems,
  getItemAdvanced,
  updateItemAdvanced,
  getPriceCategories,
  getPriceCategoryItems,
  getAddonMappings,
  getChargeGroups,
  getCharges,
};

export default ItemService;
